exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".companyPays button{margin:25px 0 60px}.companyPays a{font-size:14px;color:#115ed0;display:inline-block;margin-bottom:5px}", "", {"version":3,"sources":["/home/bamboo/applications/bamboo-home/xml-data/build-dir/AAI-SCFR-JOB1/src/page-components/src/page-components/CompanyPaysPage.scss"],"names":[],"mappings":"AAEA,oBAEI,kBAAmB,CAFvB,eAMI,eACA,cACA,qBACA,iBAAkB,CACnB","file":"CompanyPaysPage.scss","sourcesContent":["@import '../styles/colors';\n\n.companyPays {\n  button {\n    margin: 25px 0 60px;\n  }\n\n  a {\n    font-size: 14px;\n    color: $blue-link;\n    display: inline-block;\n    margin-bottom: 5px;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/page-components/CompanyPaysPage.scss
// module id = 1418
// module chunks = 0